export const getBehaviourFuelSavingsOverTimeRespMaritime = () => {
  return {
    baseline: {
      value: 55.5,
      standardError68: 0.057,
      standardError95: 0.112,
    },
    periods: [
      {
        timestamp: 1733011200000,
        countEventsPerformable: 10179,
        countEventsPerformed: 10179,
        value: {
          value: 67.9,
          standardError68: 1.2,
          standardError95: 1.4,
        },
        valueChangeFromBaseline: {
          value: 12.4,
          standardError68: 1.2,
          standardError95: 1.5,
        },
      },
      {
        timestamp: 1735689600000,
        countEventsPerformable: 7736,
        countEventsPerformed: 7736,
        value: {
          value: 67,
          standardError68: 1.2,
          standardError95: 1.5,
        },
        valueChangeFromBaseline: {
          value: 11.5,
          standardError68: 1.2,
          standardError95: 1.5,
        },
      },
      {
        timestamp: 1738368000000,
        countEventsPerformable: 7726,
        countEventsPerformed: 7726,
        value: {
          value: 70.8,
          standardError68: 1.3,
          standardError95: 1.5,
        },
        valueChangeFromBaseline: {
          value: 20.3,
          standardError68: 1.3,
          standardError95: 1.5,
        },
      },
    ],
  };
};
